var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApprovingArrowLinear(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 142,
    viewBox: "0 0 142 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 71,
    r: 71,
    fill: "#F3BA2F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.1077 59.9761C99.297 61.1253 99.297 62.9886 98.1077 64.1379C96.9184 65.2871 94.9901 65.2871 93.8008 64.1379L73.9955 44.9997L73.9955 103.999C73.9955 105.656 72.6523 106.999 70.9955 106.999C69.3386 106.999 67.9955 105.656 67.9955 103.999L67.9955 45.0087L48.1988 64.1384C47.0095 65.2876 45.0813 65.2876 43.892 64.1384C42.7027 62.9891 42.7027 61.1259 43.892 59.9766L68.7888 35.9186C68.8075 35.8995 68.8266 35.8806 68.8459 35.8619C69.8368 34.9045 71.3405 34.7447 72.5025 35.3826C72.7356 35.5105 72.955 35.6704 73.1537 35.8625L73.1839 35.892L98.1077 59.9761Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovingArrowLinear);
export default __webpack_public_path__ + "static/media/approvingArrowLinear.478c1102.svg";
export { ForwardRef as ReactComponent };